import layoutAdmin from '@/layouts/layoutAdmin.vue';
import pageNotFound from '@/views/utils/pageNotFound.vue';
import dashboard from '@/views/module/dashboard/dashboard.vue';
import featuresList from '@/views/module/administration/moduleDashboard.vue';


export default [
    {
      path: '/home',
      component: layoutAdmin,
      meta: {
        UserLoggedIn: true,
        breadcrumb: 'Dashboard',
      },
      redirect(){
        return '/home/dashboard'
      },
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          meta: {
            breadcrumb: ['Dashboard']
          },
          component: dashboard,
        },
        {
          path: '/module/:prefix',
          name: 'module-features',
          meta: {
            breadcrumb: ['Module Features'],
          },
          component: featuresList,
        },
        
      ],
      
    },
    {
          path: '/pageNotFound',
          name: 'pageNotFound',
          meta: {
            breadcrumb: ['Dashboard','Page Not Found'],
          },
          component: pageNotFound,
        },
  ]


  